import { YStack, XStack, Text, styled } from 'tamagui'
import { Card } from '../ui'
import { copy } from '../../content/copy'

const Section = styled(YStack, {
  name: 'SocialProofSection',
  paddingHorizontal: '$6',
  paddingVertical: '$16',
  backgroundColor: '$background',

  '$md': {
    paddingHorizontal: '$4',
    paddingVertical: '$10',
  },
})

const Container = styled(YStack, {
  name: 'Container',
  maxWidth: 1200,
  marginHorizontal: 'auto',
  width: '100%',
  gap: '$10',
})

const Header = styled(YStack, {
  name: 'Header',
  gap: '$3',
  marginBottom: '$4',
})

const HeaderRow = styled(XStack, {
  name: 'HeaderRow',
  alignItems: 'flex-start',
  gap: '$4',
})

const SectionNumber = styled(Text, {
  name: 'SectionNumber',
  fontFamily: '$accent',
  fontSize: '$2',
  color: '$textMuted',
  letterSpacing: 2,
})

const SectionTitle = styled(Text, {
  name: 'SectionTitle',
  fontFamily: '$accent',
  fontSize: '$3',
  color: '$orangePrimary',
  letterSpacing: 2,
  textTransform: 'uppercase',
})

const MainHeader = styled(Text, {
  name: 'MainHeader',
  // @ts-ignore - Tamagui's `render` controls the underlying HTML element on web
  render: 'h2',
  fontFamily: '$heading',
  fontSize: '$8',
  fontWeight: '600',
  color: '$textPrimary',
  marginTop: '$4',

  '$md': {
    fontSize: '$7',
  },
})

const TestimonialsGrid = styled(YStack, {
  name: 'TestimonialsGrid',
  gap: '$6',

  '$gtMd': {
    flexDirection: 'row',
    gap: '$6',
  },
})

const TestimonialCard = styled(Card, {
  name: 'TestimonialCard',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
  minWidth: 0,
  gap: '$5',
  justifyContent: 'space-between',

  '$sm': {
    flexBasis: 'auto',
    flexShrink: 0,
    padding: '$5',
  },
})

const QuoteMark = styled(Text, {
  name: 'QuoteMark',
  fontFamily: '$heading',
  fontSize: '$10',
  color: '$orangePrimary',
  opacity: 0.3,
  lineHeight: '$7',
  marginTop: -8,
})

const Quote = styled(Text, {
  name: 'Quote',
  fontFamily: '$body',
  fontSize: '$5',
  lineHeight: '$6',
  color: '$textPrimary',
  fontStyle: 'italic',

  '$md': {
    fontSize: '$4',
    lineHeight: '$5',
  },
})

const Attribution = styled(YStack, {
  name: 'Attribution',
  gap: '$2',
  paddingTop: '$4',
  borderTopWidth: 1,
  borderTopColor: '$border',
})

const AttributionName = styled(Text, {
  name: 'AttributionName',
  fontFamily: '$body',
  fontSize: '$4',
  fontWeight: '600',
  color: '$textPrimary',
})

const AttributionDetail = styled(Text, {
  name: 'AttributionDetail',
  fontFamily: '$body',
  fontSize: '$3',
  color: '$textSecondary',
})

const ResultBadge = styled(XStack, {
  name: 'ResultBadge',
  backgroundColor: 'rgba(96, 165, 250, 0.1)',
  paddingHorizontal: '$3',
  paddingVertical: '$2',
  borderRadius: '$3',
  alignSelf: 'flex-start',
})

const ResultText = styled(Text, {
  name: 'ResultText',
  fontFamily: '$body',
  fontSize: '$3',
  fontWeight: '500',
  color: '#60A5FA',
})

export function SocialProofSection() {
  const { sectionNumber, sectionTitle, header, testimonials } = copy.socialProof

  return (
    <Section>
      <Container>
        <Header>
          <HeaderRow>
            <SectionNumber>{sectionNumber}</SectionNumber>
            <SectionTitle>{sectionTitle}</SectionTitle>
          </HeaderRow>
          <MainHeader>{header}</MainHeader>
        </Header>

        <TestimonialsGrid>
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} variant="subtle">
              <YStack gap="$3">
                <QuoteMark>"</QuoteMark>
                <Quote>{testimonial.quote}</Quote>
              </YStack>

              <Attribution>
                <AttributionName>{testimonial.name}</AttributionName>
                <AttributionDetail>
                  {testimonial.title}, {testimonial.company}
                </AttributionDetail>
                <ResultBadge>
                  <ResultText>{testimonial.result}</ResultText>
                </ResultBadge>
              </Attribution>
            </TestimonialCard>
          ))}
        </TestimonialsGrid>
      </Container>
    </Section>
  )
}
